import React from 'react'
import { Trans } from 'react-i18next'
import { Provider } from 'react-redux'

import clsx from 'clsx'
import { TFunction } from 'i18next'

import RootContext from '../../../context/RootContext'
import MorningScanResult from '../../../features/MorningScanResult'
import ScanInput from '../../../features/ScanInput'
import { store } from '../../../redux/store'
import { BatchHubOutParams } from '../../../types/BatchHubOut'

export interface InventoryScanProps {
  t?: TFunction
  trans?: typeof Trans
  subcoId: number
  onBatchHubOut: (params: BatchHubOutParams) => Promise<void> | void
  isBatchHubOutDone?: boolean
  className: string
}

export const InventoryScan: React.FC<InventoryScanProps> = ({
  t,
  trans,
  subcoId,
  className,
  onBatchHubOut,
  isBatchHubOutDone,
}) => {
  const contextValue = React.useMemo(() => ({ t, trans }), [t, trans])

  return (
    <RootContext.Provider value={contextValue}>
      <Provider store={store}>
        <div className={clsx('flex flex-col gap-8', className)}>
          <ScanInput subcoId={subcoId} />
          <MorningScanResult
            subcoId={subcoId}
            onBatchHubOut={onBatchHubOut}
            isBatchHubOutDone={isBatchHubOutDone}
          />
        </div>
      </Provider>
    </RootContext.Provider>
  )
}

export default InventoryScan
